import React, { useEffect, useState, useMemo } from 'react';
import { getdata, formatdate } from "../../util/global";
import PatientAdminTable from './PatientAdminTable';
import PatientView from './PatientView';

const PatientAdmin = () => {
  const [patientdata, setpatientdata] = useState([]);
  const [appointmentdata, setappointmentdata] = useState([]);
  const [prescriptiondata, setprescriptiondata] = useState([]);
  
  const [searchquery, setsearchquery] = useState("");
  const [mode, setmode] = useState("");
  const [formdata, setformdata] = useState({ name: "", phonenumber: "", _id: null });

  const fetchdata = async () => {
    try {
      // Parallel fetch for clinical context
      const patdata = await getdata({ filter: { datatype: "patientdata" } });
      setpatientdata(patdata.reverse());
      
      const apptdata = await getdata({ filter: { datatype: "appointmentdata" } });
      setappointmentdata(apptdata.reverse());

      const presdata = await getdata({ filter: { datatype: "prescriptiondata" } });
      setprescriptiondata(presdata.reverse());
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchdata(); }, []);

  const filteredpatients = useMemo(() => {
    return patientdata.filter(p => 
      p.name?.toLowerCase().includes(searchquery.toLowerCase()) || 
      p.phonenumber?.includes(searchquery)
    );
  }, [patientdata, searchquery]);

  const openview = (item) => {
    setformdata({ ...item });
    setmode("viewpatient");
  };

  const openedit = (item) => {
    setformdata({ ...item });
    setmode("editpatient");
  };

  return (
    <div className="content-area">
      <div className="table-header-row">
        <h1 className="dash-title">Patient Management</h1>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input 
            type="text" 
            placeholder="Search name or phone..." 
            className="form-input" 
            style={{ width: '250px' }}
            value={searchquery}
            onChange={(e) => setsearchquery(e.target.value)}
          />
          <button className="btn-blue" onClick={() => {
            setformdata({ name: "", phonenumber: "", _id: null });
            setmode("editpatient");
          }}>+ New Patient</button>
        </div>
      </div>

      <PatientAdminTable 
        data={filteredpatients} 
        openview={openview} 
        openedit={openedit} 
      />
      
      <PatientView 
        mode={mode} 
        setmode={setmode} 
        formdata={formdata} 
        appointmentdata={appointmentdata.filter(a => a._patientid === formdata._id || a.phonenumber === formdata.phonenumber)}
        prescriptiondata={prescriptiondata.filter(p => p._patientid === formdata._id || p.phonenumber === formdata.phonenumber)}
      />
    </div>
  );
};

export default PatientAdmin;